import {RouteObject} from 'react-router';
import {SiteContactUsPage} from '@app/contact/site-contact-us-page';
import {SiteCustomPage} from '@app/pages/site-custom-page';

/**
 * CUSTOM(albaniantheatre): overrides for the foundation "commonRoutes" so that
 * custom pages (Privacy Policy, Terms of Service) and the contact page render
 * inside the site layout instead of swapping in a different header. Must be
 * registered before commonRoutes in app-router.tsx so these win.
 */
export const appCommonRoutes: RouteObject[] = [
  {
    path: 'contact',
    element: <SiteContactUsPage />,
  },
  {
    path: 'pages/:pageSlug',
    element: <SiteCustomPage />,
  },
  {
    path: 'pages/:pageId/:pageSlug',
    element: <SiteCustomPage />,
  },
];
